import React from 'react';
import StatusBadge from '../../Components/StatusBadge';
import { SEVERITY_LABEL } from '../constants';

const labelFor = (severity) => (
    SEVERITY_LABEL[severity] || (severity ? severity.charAt(0).toUpperCase() + severity.slice(1) : 'Unrated')
);

export default function SeverityPill({ severity }) {
    return <StatusBadge status={severity || 'unclassified'} label={labelFor(severity)} />;
}
